
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.907 10.56V5.061c0-.515-.343-.859-.859-.859H9.76c-.515 0-.858.344-.858.859s.343.859.858.859h14.43v3.865h-8.932c-6.013 0-11.338 4.295-12.627 10.307l-.343 1.89a.668.668 0 00.172.687c.171.172.43.343.687.343h24.221c.258 0 .516-.085.688-.343a.668.668 0 00.171-.687l-2.319-11.424zM4.177 21.295l.171-.86c1.117-5.153 5.755-8.932 10.909-8.932h9.104l1.976 9.792H4.177z","fill":"#fff"}}),_c('path',{attrs:{"d":"M2.974 25.504H27.71","stroke":"#fff","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12.68 18.89a1.89 1.89 0 100-3.779 1.89 1.89 0 000 3.78zm5.926 0a1.89 1.89 0 100-3.779 1.89 1.89 0 000 3.78z","fill":"#fff"}})])
          )
        }
      }
    